function Footer() {
  return (
    <footer className="col-span-5 bg-gray-200 text-center 
    lg:text-left xl:col-span-8">
      <div
        className="text-gray-700 text-center p-4"
      >
        © 2023 Copyright: TeamNaDa
        <a className="text-gray-800 my-2" href="/#">
           {` Contact Me: 123-456-7890`}
        </a>
      </div>
    </footer>
  );
}

export default Footer;
